export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7838.1de6b859.jpg";